export default "__VITE_ASSET__BrEI4i1v__"